<template>
  <div class="new-dashboard-page">
    <el-card>
      <el-row>
        <!--left block-->
        <el-col :lg="18" style="padding-right: 0; padding-bottom: 0">
          <el-row>
            <el-col :sm="12" :lg="11">
              <v-chart :option="jobQueuesOptions" :auto-resize="true" autoresize></v-chart>
            </el-col>
            <el-col :sm="12" :lg="6">
              <v-chart :option="unprocessedOrdersOpts" :auto-resize="true" autoresize></v-chart>
            </el-col>
            <el-col :sm="12" :lg="7">
              <v-chart :option="inventorySyncOpts" :auto-resize="true" autoresize></v-chart>
            </el-col>
          </el-row>
          <el-row>
            <el-col :lg="24">
              <v-chart :option="processedOrdersOpts" style="height: 200px; width: 100%;" :auto-resize="true"
                       autoresize></v-chart>
            </el-col>
          </el-row>
          <el-row>
            <el-col :lg="11">
              <v-chart :option="salesDataOpts" style="height: 400px; width: 100%;" :auto-resize="true"
                       autoresize></v-chart>
            </el-col>
            <el-col :lg="13">
              <v-chart :option="monthlySalesDataOpts" style="height: 400px; width: 100%;" :auto-resize="true"
                       autoresize></v-chart>
            </el-col>
          </el-row>
        </el-col>

        <!--right block-->
        <el-col :lg="6" style="padding-left: 0; padding-right: 0">
          <el-row>
            <el-col :lg="24" style="padding-right: 0;">
              <div class="dashboard-box">
                <h3>Inventory Last Sync</h3>
                <div class="box-content">
                  <div class="inventory-status">
                    <span><b><i class="fab fa-microsoft"></i> From D365:</b>
                    <ul>
                      <li>CA: {{ this.d365WebhookCA }} PCT</li>
                      <li>USA: {{ this.d365WebhookUS }} PCT</li>
                    </ul></span>
                  </div>
                </div>
                <div class="box-content">
                  <div class="inventory-status">
                    <span><b><i class="fab fa-shopify"></i> To Shopify:</b> {{ this.invLastSyncWithShopify }} PCT</span>
                  </div>
                </div>
                <div class="box-content" style="margin-bottom: 0">
                  <div class="inventory-status">
                    <span><b><i class="fab fa-amazon"></i> To Amazon:</b> {{ this.invLastSyncWithAmazon }} PCT</span>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :lg="24" style="padding-right: 0;">
              <div class="dashboard-box">
                <a href="/monitoring/kitsilano/hold"><h3 style="margin-bottom: 0"><i class="fas fa-store"></i> # of Hold
                  Orders: {{ this.holdOrders }}</h3></a>
              </div>
            </el-col>

            <el-col :lg="24" style="padding-right: 0;">
              <div class="dashboard-box">
                <h3>Order Fulfillments</h3>
                <div class="box-content">
                  <div class="inventory-status">
                    <span><b><i class="fas fa-file-import"></i> Last Processed Fulfillment File from NLS:</b><br/>
                      {{ this.nlsLastFulfillmentFile }} PCT</span>
                  </div>
                </div>
                <div class="box-content">
                  <div class="inventory-status">
                    <span><b><i class="fas fa-file-import"></i> Last Processed Fulfillment File from JAS:</b><br/>
                      {{ this.jasLastFulfillmentFile }} PCT</span>
                  </div>
                </div>
                <div class="box-content">
                  <div class="inventory-status">
                    <span><b><i class="fas fa-file"></i> Pending Fulfillment Files:</b> {{
                        this.pendingFulfillmentFiles
                      }}</span>
                  </div>
                </div>
                <div class="box-content">
                  <div class="inventory-status">
                    <span><b><i class="fas fa-warehouse"></i> Unprocessed Warehouse Fulfillment:</b> {{
                        this.unprocessedWarehouseFulfillment
                      }}</span>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
// Import the ECharts modules that you need
import * as ECharts from 'echarts/core'

import {BarChart, LineChart, PieChart} from 'echarts/charts'
import {GridComponent, LegendComponent, TitleComponent, TooltipComponent,} from 'echarts/components'
import {CanvasRenderer} from 'echarts/renderers'
import VueECharts, {THEME_KEY} from 'vue-echarts'
import axios from '../repositories/Repository';
import {RepositoryError} from "../repositories";

ECharts.use([
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  BarChart,
  CanvasRenderer,
  PieChart,
  LineChart,
  GridComponent,
])

export default {
  name: "Dashboard",
  components: {
    'v-chart': VueECharts,
  },
  provide: {
    [THEME_KEY]: "light"
  },
  data() {
    return {
      loading: false,
      d365Loading: false,
      timer: null,
      invLastSyncWithAmazon: null,
      invLastSyncWithShopify: null,
      d365Webhook: null,
      holdOrders: null,
      nlsLastFulfillmentFile: null,
      jasLastFulfillmentFile: null,
      pendingFulfillmentFiles: null,
      unprocessedWarehouseFulfillment: null,
      d365Metrics: null,
      d365BatchJobs: null,
      d2c_no_fill_rate: 0,
      jobQueuesOptions: {
        title: {text: "Kitsilano Job Queues", left: "center", top: 20},
        tooltip: {trigger: "item", formatter: "{b} : {c}"},
        legend: {orient: 'horizontal', bottom: 20, type: 'scroll',},
        xAxis: {data: []},
        yAxis: {},
        series: [
          {name: 'Shopify', type: 'bar', data: []},
          {name: 'Amazon', type: 'bar', data: []},
          {name: 'D365', type: 'bar', data: []},
          {name: 'OMS', type: 'bar', data: []},
          {name: 'Payment Capture', type: 'bar', data: []},
          {name: 'Failed', type: 'bar', data: []},
          {name: 'Shopify Delayed', type: 'bar', data: []},
          {name: 'Default', type: 'bar', data: []},
        ]
      },
      unprocessedOrdersOpts: {
        title: {text: "Unprocessed Orders", left: "center", top: 20},
        tooltip: {trigger: "item", formatter: "{b} : {c}"},
        legend: {orient: 'horizontal', bottom: 20, type: 'scroll',},
        xAxis: {data: []},
        yAxis: {},
        series: []
      },
      inventorySyncOpts: {
        title: {text: "Inventory Sync Pending", left: "center", top: 20},
        tooltip: {trigger: "item", formatter: "{b} : {c}"},
        legend: {orient: 'horizontal', bottom: 20, type: 'scroll',},
        xAxis: {data: []},
        yAxis: {},
        series: []
      },
      processedOrdersOpts: {
        title: {text: "Processed Orders", left: "center", top: 20},
        tooltip: {trigger: "item", formatter: "{a} {b} : Processed {c} Orders"},
        legend: {orient: 'horizontal', bottom: 20, type: 'scroll',},
        xAxis: {
          data: Array.from({length: 24}, (_, index) => {
            return `${index.toString().padStart(2, '0')}:00`;
          })
        },
        yAxis: {},
        series: []
      },
      salesDataOpts: {
        title: {text: "Daily Sales", left: "center", top: 20},
        tooltip: {trigger: "item", formatter: "{b} : ${c}"},
        legend: {orient: 'horizontal', left: "center", bottom: 20, type: 'scroll',},
        series: [{type: 'pie', radius: ['35%', '60%'], label: {show: false}, data: []}]
      },
      monthlySalesDataOpts: {
        title: {text: "Trailing 12 Months Sales", left: "center", top: 20},
        tooltip: {trigger: "item", formatter: "{a} {b} : ${c}"},
        legend: {orient: 'horizontal', bottom: 20, type: 'scroll',},
        xAxis: {data: this.getLast13Months()},
        yAxis: {},
        series: []
      },
    };
  },
  methods: {
    fetchData() {
      const processKitsilanoMetrics = () => {
        axios.get('/dashboard/kitsilano-metrics').then(response => {
          this.updateQueueData(response.data);
          this.holdOrders = response.data.orders.holds;
          this.nlsLastFulfillmentFile = response.data.orders.nls_last_fulfillment_file;
          this.jasLastFulfillmentFile = response.data.orders.jas_last_fulfillment_file;
          this.pendingFulfillmentFiles = response.data.orders.pending_fulfillment_files;
          this.unprocessedWarehouseFulfillment = response.data.orders.unprocessed_warehouse_fulfillment;
          this.updateUnprocessedData(response.data.orders.unprocessed_orders);
          this.updateProcessedOrderData(response.data.orders.processed_today);
        }).catch(err => handleError(err));
      };

      const processQueueMetrics = () => {
        axios.get('/dashboard/queue-metrics').then(response => {
          this.updateInventorySyncData(response.data);
        }).catch(err => handleError(err));
      };

      const processSales = () => {
        axios.get('/dashboard/sales').then(response => {
          this.updateSalesData(response.data.today);
          this.updateMonthlySalesData(response.data.monthly);
        }).catch(err => handleError(err));
      };

      const handleError = (err) => {
        if (err instanceof RepositoryError) {
          return;
        }
        this.loading = false;
        this.d365Loading = false;
        throw err;
      };

      processKitsilanoMetrics();
      processQueueMetrics();
      processSales();
    },

    updateQueueData(kitsMetrics) {
      this.jobQueuesOptions.series[0].data = [{
        name: "Shopify unprocessed order jobs (order jobs that's not processed)",
        value: kitsMetrics.queues.shopify
      }];
      this.jobQueuesOptions.series[1].data = [{
        name: "Amazon unprocessed order jobs (order jobs that's not processed)",
        value: kitsMetrics.queues.amazon
      }];
      this.jobQueuesOptions.series[2].data = [{
        name: "Order process jobs that's waiting to be sent to D365",
        value: kitsMetrics.queues.d365
      }];
      this.jobQueuesOptions.series[3].data = [{
        name: "Order process jobs that's waiting to be sent to OMS",
        value: kitsMetrics.queues.oms
      }];
      this.jobQueuesOptions.series[4].data = [{
        name: "Shopify payment capture jobs",
        value: kitsMetrics.queues.capture
      }];
      this.jobQueuesOptions.series[5].data = [{
        name: "Kitsilano failed jobs",
        value: kitsMetrics.queues.fails_today
      }];
      this.jobQueuesOptions.series[6].data = [{
        name: 'Default job queues (anything that does not specified which queue to use)',
        value: kitsMetrics.queues.jobs
      }];
      this.jobQueuesOptions.series[7].data = [{
        name: "Shopify delayed orders",
        value: kitsMetrics.queues.shopify_delayed
      }];
    },
    updateUnprocessedData(unprocessedOrders) {
      this.unprocessedOrdersOpts.series = Object.keys(unprocessedOrders).map((key) => {
        return {
          name: this.formatString(key),
          type: 'bar',
          data: [{name: this.formatString(key), value: unprocessedOrders[key]}]
        };
      });
    },
    updateInventorySyncData(data) {
      this.inventorySyncOpts.series = Object.keys(data).map((key) => {
        if (key === 'shopify_last_sync' || key === 'amazon_last_sync' || key === 'd365_last_webhook') {
          return;
        }
        return {name: this.formatString(key), type: 'bar', data: [{name: this.formatString(key), value: data[key]}]};
      });

      this.d365WebhookCA = data.d365_last_webhook[0];
      this.d365WebhookUS = data.d365_last_webhook[1];
      this.invLastSyncWithShopify = data.shopify_last_sync;
      this.invLastSyncWithAmazon = data.amazon_last_sync;
    },
    updateProcessedOrderData(processedOrders) {
      this.processedOrdersOpts.series = Object.keys(processedOrders).map((key) => {
        return {name: this.formatString(key), type: 'line', smooth: true, data: this.convertToObjectArray(processedOrders[key])};
      });
    },
    updateSalesData(data) {
      this.salesDataOpts.series[0].data = this.convertToObjectArray(data);
    },
    updateMonthlySalesData(data) {
      this.monthlySalesDataOpts.series = Object.keys(data).map((key) => {
        return {name: this.formatString(key), type: 'line', smooth: true, data: this.convertToObjectArray(data[key])};
      });
    },
    convertToObjectArray(obj) {
      return Object.keys(obj).map((key) => {
        return {name: this.formatString(key), value: obj[key]};
      });
    },
    formatString(str) {
      return str.replace(/_/g, ' ').toUpperCase().replace("SHOPIFY", "Shopify").replace("AMAZON", "Amazon");
    },
    getLast13Months() {
      let result = [];
      let date = new Date();
      for (let i = 0; i < 13; i++) {
        let monthString = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
        result.unshift(monthString);
        date.setMonth(date.getMonth() - 1);
      }
      return result;
    },
  },
  mounted() {
    this.loading = true;
    this.d365Loading = true;
    this.fetchData();
    // this.timer = setInterval(this.fetchData, 1000 * 60 * 5);
  },
};
</script>
